import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionSubtitle: {
    id: 'Section Subtitle',
    defaultMessage: 'Section Subtitle',
  },
  subtitle: { id: 'Subtitle', defaultMessage: 'Subtitle' },
  textFiedDescription: {
    id: 'textFiedDescription',
    defaultMessage: 'Enter the text that will be displayed in the block.',
  },
  subtitleLink: { id: 'subtitleLink', defaultMessage: 'Link URL' },
  subtitleLinkDescription: {
    id: 'subtitleLinkDescription',
    defaultMessage: 'If filled in, the subtitle will be a link.',
  },
  align: { id: 'Align', defaultMessage: 'Align' },
});

export const Schema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.sectionSubtitle),
        fields: ['subtitle', 'subtitleLink', 'align'],
      },
    ],
    properties: {
      subtitle: {
        title: intl.formatMessage(messages.subtitle),
        description: intl.formatMessage(messages.textFiedDescription),
      },
      subtitleLink: {
        title: intl.formatMessage(messages.subtitleLink),
        description: intl.formatMessage(messages.subtitleLinkDescription),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'Description'],
        allowExternals: true,
      },
      align: {
        title: intl.formatMessage(messages.align),
        widget: 'text_align_widget',
        default: 'center',
        actions: ['left', 'center', 'right'],
      },
    },
    required: ['subtitle'],
  };
};
